module.exports = __webpack_public_path__ + "static/media/огр мини.86af5fac.jpg";